import { Directive, ElementRef, Input } from '@angular/core';
import { AuthenticationService } from '../services/shared/auth.service';

@Directive({
  selector: '[appCanAccess]'
})
export class CanAccessDirective {

  constructor(
    private elRef: ElementRef,
    private authService: AuthenticationService,
  ) { }

  @Input() accessPolicy: any;

  loggedUserRole: any;
  userPolicies: any;
  macthedPolicies: any = [];

  ngAfterViewInit(): void {

    //console.log(this.accessPolicy, 'accessPolicy')
    // this.elRef.nativeElement.style.color = this.defaultColor;
    this.setAccess()
  }


  setAccess() {
    this.userPolicies = this.authService.getLoggedUser().policies;
    //console.log(this.accessPolicy, 'accessPolicy')
    // this.userPolicies.forEach(e => {
    const found = this.userPolicies.filter(value => this.accessPolicy.includes(value.id));

    if (found && found.length > 0) {
      this.elRef.nativeElement.style.display = 'contents';
      //this.macthedPolicies.push(e.policy);
    } else {
      if (!this.macthedPolicies.includes(this.accessPolicy)) {
        //console.log(e.policy, 'Policy Not Matched',  this.accessPolicy)
        this.elRef.nativeElement.style.display = 'none';
      }

    }
    // });

  }

}
